import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Box } from '@mantine/core';
import heic2any from "heic2any";

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";

const BarangProjectNotaFotoFileInput = ({ stateData, fnOnAdded }) => {

  const refFileInput = React.useRef(null);

  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorUpload: 'BarangProjectNotaFotoFileInput-1',
    errorSubmitData: 'BarangProjectNotaFotoFileInput-2',
  })

  const [data, setData] = React.useState({
    submitLoading: false,
    fileUploadingProgress: 0,

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const handleFileUpload = async (event) => {
    const file = event;

    setData(d => ({ ...d, submitLoading: true }));

    if (file && file.type === "image/heic") {
      try {
        const convertedBlob = await heic2any({ blob: file, toType: "image/jpeg" });
        const jpegFile = new File([convertedBlob], `${file.name}.jpeg`, { type: "image/jpeg" });
        refFileInput.current.value = '';
        submitData(jpegFile);
      } catch (error) {
        setData(d => ({ ...d, submitLoading: false }));

        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Konversi HEIC gagal',
            show: true
          }
        }));
      }
    } else {
      submitData(file);
      refFileInput.current.value = '';
    }
  }

  const fileChecker = (e) => {
    try {
      const value = e.target.files[0];

      if (value && (typeof value === 'object')) {
        const tipe = value.type.split('/')[0];

        if (tipe !== 'image') {
          refFileInput.current.value = '';

          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Tipe file harus berupa image.',
              show: true
            }
          }));
        } else {
          handleFileUpload(value);
        }
      }
    } catch (error) {
      //
    }
  }

  const submitData = (stateFile) => {
    const formDT = new FormData();
    const formDTHeader = { Accept: 'application/json', 'Content-Type': 'multipart/form-data' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_id', stateData.projectId);
    formDT.append('project_process', stateData.projectProcess);
    formDT.append('project_is_cancel', stateData.projectIsCancel);

    formDT.append('photos[0]', stateFile);
    formDT.append('image_max_size_in_mb', utils.imageMaxSizeUploadFotoInMB);

    // info: di FE ini tidak ada array MIME TYPE, di handle di BE dgn format image only.

    axios({
      method: 'post',
      url: BE_API_TWO + '/add_project_barang_foto_nota',
      data: formDT,
      headers: formDTHeader,
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

        setData(d => ({ ...d, fileUploadingProgress: percentCompleted }))
      }
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, submitLoading: false, fileUploadingProgress: 0 }));

      if (response.data.flag_status === 'isset') {
        fnOnAdded(response.data.data);
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'error') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Error : ' + response.data.pesan,
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'wrong-type') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: `"${response.data.suspect}" tidak sesuai dengan format yang diizinkan (${response.data.allowed}).`,
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'wrong-size') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: `"${response.data.suspect}" melebihi ukuran yang diizinkan (${response.data.max_size}).`,
            show: true
          }
        }))
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        submitLoading: false,
      }))

      notifications.show({
        id: notificationId.current.errorSubmitData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  return (
    <>
      <input
        type='file'
        ref={refFileInput}
        onChange={(e) => fileChecker(e)}
        style={{ display: 'none' }}
      />

      <Box
        mt='md'
        p='.5rem'
        size="xs"
        onClick={!data.submitLoading ? () => refFileInput.current.click() : () => { }}

        sx={(tema) => ({
          fontSize: tema.fontSizes.sm,
          textAlign: 'center',
          borderWidth: '1px',
          borderStyle: 'dashed',
          borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
          borderRadius: tema.radius.sm,
          color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
          cursor: 'pointer',
          backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.fn.rgba(tema.colors.blue[9], 0.1),


          '&:hover': {
            backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
          }
        })}
      >
        {data.submitLoading ? `Uploading ${data.fileUploadingProgress}%` : 'Upload Image Here'}
      </Box>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />
    </>
  )
}

export default BarangProjectNotaFotoFileInput;